
import { useState } from "react"
import {
  Collapse,
  Navbar,
  NavbarToggler,
  NavbarBrand,
  Nav,
  NavItem,
  NavLink,
} from "reactstrap"

import { useAuth } from "../../Contexts/AuthContext"

function ResponsiveNavbar() {
  const [collapsed, setCollapsed] = useState(true)
  const { user } = useAuth()
  const toggleNavbar = () => setCollapsed(!collapsed)

  const authenticatedLinks = [
    // {
    //   name: "Profile",
    //   path: "/profile",
    // },
    {
      name: "Expense Groups",
      path: "/expense-groups",
    },
    {
      name: "Create Expense Group",
      path: "/create-edit-expense-group",
    },
    {
      name: "Logout",
      path: "/logout",
    },
  ]

  const unauthenticatedLinks = [
    {
      name: "Login",
      path: "/login",
    },
    {
      name: "Register",
      path: "/register",
    },
  ]

  return (
    <div>
      <Navbar color="faded" light>
        <NavbarBrand href="/" className="me-auto">
          Symfonia
        </NavbarBrand>
        <NavbarToggler onClick={toggleNavbar} className="me-2" />
        <Collapse isOpen={!collapsed} navbar>
          <Nav navbar>
            {(user ? authenticatedLinks : unauthenticatedLinks).map(
              (link, index) => (
                <NavItem key={index}>
                  <NavLink href={link.path}>{link.name}</NavLink>
                </NavItem>
              )
            )}
          </Nav>
        </Collapse>
      </Navbar>
    </div>
  )
}

export default ResponsiveNavbar
